import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import PndRestApi from "src/utils/pnd/PndRestApi";
import TerritoryAreaUpdate from "./TerritoryAreaUpdate";
import { showNotification, successNofication } from "src/shared/components/Notification";

import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
const TerritoryAreaModal = ({ modalShow, setModalShow, isTitle, dataInfo }) => {
    const [isRedirect, setIsRedirect] = useState(false);
    const [loading, setLoading] = useState(false);

    if (isRedirect) {
        window.location.reload();
        
    }

    let Icon;
   

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }


    const handleSubmit = async (formValues) => {
        try {
            let obj = {};
            setLoading(true);
            const selectedValues = formValues.areaInfo || []; // Assuming 'areaInfo' is the field name
            const areaIds = selectedValues.map(option => option.value).join(', ');
            obj["regionCode"] = formValues["regionCode"];
            obj["regionName"] = formValues["regionName"];
            obj["regionAreaIds"] = areaIds;
            obj["regionId"] = formValues["regionId"];
            // Submit form with formatted value

            const response = await PndRestApi.UpdateTerritoryAreas(obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                  }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );

        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4
                        className="text-modal  modal__title mt-1 text-uppercase"
                        style={{ color: "#2DD2E7" }}
                    >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light"> */}
                                {/* form  */}

                                <TerritoryAreaUpdate
                                    onSubmit={handleSubmit} dataInfo={dataInfo} regionId={dataInfo?.regionId}
                                />

                            {/* </span>
                        </span> */}
                    </div>


                </ModalBody>
            </Modal>


        </div>
    );
};



export default connect((state) => ({
    rtl: state.rtl,
}))(TerritoryAreaModal);
